import type { SavedReply } from '../hooks/useSavedReplies';

export default function (savedReply: SavedReply) {
  // Default replies on the BE will always start at 100
  return savedReply.replyIndex >= 100;
}
